/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { LeaderboardComponent } from './leaderboard.component';
import { FeedLeaderboardComponent } from '../common/feed-leaderboard/feed-leaderboard.component';
import { CommunityModule } from '../common/community/community.module';
import { CommonComponentsModule } from '../common/components/common-components.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    UIRouterModule,
    CommonComponentsModule,
    CommunityModule,
    SharedModule,
  ],
  declarations: [
    LeaderboardComponent,
    FeedLeaderboardComponent,
  ],
  exports: [
    LeaderboardComponent,
    FeedLeaderboardComponent,
  ],
})
export class LeaderboardModule {}
